import Vue from 'vue';
import VueI18n from 'vue-i18n';
import nlElementUiMessages from 'element-ui/lib/locale/lang/nl';
import enElementUiMessages from 'element-ui/lib/locale/lang/en';
import frElementUiMessages from 'element-ui/lib/locale/lang/fr';
import plElementUiMessages from 'element-ui/lib/locale/lang/pl';
import nlAppMessages from './nl';
import enAppMessages from './en';
import frAppMessages from './fr';
import plAppMessages from './pl';

Vue.use(VueI18n);

const messages = {
  en: {
    ...enElementUiMessages,
    ...enAppMessages
  },
  nl: {
    ...nlElementUiMessages,
    ...nlAppMessages
  },
  fr: {
    ...frElementUiMessages,
    ...frAppMessages
  },
  pl: {
    ...plElementUiMessages,
    ...plAppMessages
  }
};

export default new VueI18n({
  messages
});
